import { Input, List, NavBar, Picker } from 'antd-mobile'

import { 
    BodyView,
    ButtonView,
    ListView,
    PopupSelectView
} from "../../factory/ViewUtil";
import { 
    CellHeaderView,
    CellStateView,
    CellRecordView,
    CellAssetsView
} from "../../factory/CellViews";

import { 
    DownFill
} from 'antd-mobile-icons';
import React, { useEffect, useRef, useState } from 'react';
import { isLogin, RequestTransferHistory, SendTransfer } from '../../../NetworkFactory';
import { BigDecimalZero, DecimalComparedToZero, ToastContent, ToastLoading, ToDate } from '../../factory/FactoryUtil';
import { AssetsGetName, AssetsListener, AssetsListenerRemove, RefreshAssets } from '../AssetsManager';

const columnsData = [
    [
        {label : 'Coins Account' , value : '1'},
        {label : 'Future Account' , value : '2'},
        {label : 'Second Future Account' , value : '3'}
    ],
    [
        {label : 'Coins Account' , value : '1'},
        {label : 'Future Account' , value : '2'},
        {label : 'Second Future Account' , value : '3'}
    ]
]

const AssetsTransferViewController = ({goback, data}) => {

    const [formType, setFormType] = useState(data.type || '1');
    const [symbol, setSymbol] = useState('USDT');
    const [balance, setBalance] = useState('0.00');
    const [stateCode, setStateCode] = useState(3);
    const [dataSource, setDataSource] = useState([]);
    const [transferAccount, setTransferAccount] = useState([columnsData[0][0], columnsData[0][1]]);
    const [amount, setAmount] = useState('')
    
    const [visiblePopup, setVisiblePopup] = useState(false);

    const assetsData = useRef({})

    //=========================================================
    const openAccount = (item)=> {
        setVisiblePopup(false)
        setSymbol(item.symbol)
        setBalance(item.available)
    }

    const updateAccount = (form) => {
        const data = assetsData.current[form] || []
        for(let i=0;i<data.length;i++) {
            const itemData = data[i]
            if(itemData.symbol === symbol) {
                setBalance(itemData.available)
                break
            }
        }
    }
    //=========================================================

    //=========================================================
    // # 获取全部资产
    useEffect(() => {
        if(isLogin()) {
            AssetsListener('1', 'AssetsTransferViewController', response => {
                let data = response.data || []
                assetsData.current = {...assetsData.current, '1' : data}
                if(formType === '1') {
                    openAccount(data[0])
                }
            })

            AssetsListener('2', 'AssetsTransferViewController', response => {
                let data = response.data || []
                assetsData.current = {...assetsData.current, '2' : data}
                if(formType === '2') {
                    openAccount(data[0])
                }
            })

            AssetsListener('3', 'AssetsTransferViewController', response => {
                let data = response.data || []
                assetsData.current = {...assetsData.current, '3' : data}
                if(formType === '3') {
                    openAccount(data[0])
                }
            })

            return () => {
                AssetsListenerRemove('1', 'AssetsTransferViewController')
                AssetsListenerRemove('2', 'AssetsTransferViewController')
                AssetsListenerRemove('3', 'AssetsTransferViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 请求记录数据
    const requestData = () => {
        setStateCode(3)
        RequestTransferHistory().then(response => {
            const data = response.data.data || []
            setStateCode(data.length >0 ? -1 : 1)
            setDataSource(data)
        }).catch(()=> {
            setStateCode(1)
        })
    }

    useEffect(() => {
        if(isLogin()) {
            requestData()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    //=========================================================

    //=========================================================
    // # 选择币种
    const showPicker = () => {
        Picker.prompt({
            mouseWheel : true,
            columns: columnsData,
            title : <div style={{padding : '10px 0', fontSize : '17px', fontWeight : 'bold'}}>Please select transfer Account</div>,
            cancelText : '',
            confirmText : '',
            defaultValue : [transferAccount[0].value, transferAccount[1].value],
            onSelect: (val , extend) => {
                const form = val[0]
                updateAccount(form)
                if(form !== val[1]) {
                    setFormType(form)
                    setTransferAccount(extend.items)
                }
            }
        })
    }

    //=========================================================

    //=========================================================
    // # 提交划转
    const showError = () => {
        ToastContent('Transfer abnormal')
    }
    const postTransfer = () => {
        if(DecimalComparedToZero(amount) <= 0) {
            ToastContent('Invalid transfer amount')
            return
        }

        // # 提交划转资产
        ToastLoading('Transferring')
        const data = {
            from : transferAccount[0].value,
            to : transferAccount[1].value, 
            amount : BigDecimalZero(amount).toString(),
            symbol : symbol
        }
        SendTransfer(data).then(response => {
            const {status} = response.data || {}
            if(status === 200) {
                // # 提示、刷新余额、返回
                RefreshAssets('1')
                RefreshAssets('2')
                RefreshAssets('3')
                ToastContent('Transfer completed')
                goback()
                
            } else {
                showError()
            }
        }).catch(() => {
            showError()
        })
    }
    //=========================================================

    const onClickAll = () => {
        setAmount(balance)
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}></NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <List.Item style={{margin : '30px 0', textAlign : 'center'}}>
                        <div style={{fontSize : '20px', lineHeight : '1.2', padding : '0 20px'}}>Please select a transfer account</div>
                    </List.Item>
                    <List.Item style={{margin : '10px 0'}}>
                        <div style={{border : '1.8px #000 solid', borderRadius : '8px'}}>
                            <div onClick={showPicker} style={{display : 'flex', alignItems : 'center', padding : '10px 0 10px 10px'}}>
                                <div style={{width : '20px'}}>
                                    <div style={{width : '10px', height : '10px', background : '#1FC586', borderRadius : '100px'}}></div>
                                    <div style={{borderRight : '1px #E5E5E5 solid', width : '4px', height : '18px', margin : '4px 0'}}></div>
                                    <div style={{width : '10px', height : '10px', background : '#FF7878', borderRadius : '100px'}}></div>
                                </div>
                                <div style={{fontSize : '12px', marginRight : '10px'}}>
                                    <div>Form</div>
                                    <div style={{height : '20px'}}></div>
                                    <div>To</div>
                                </div>
                                <div style={{fontSize : '12px'}}>
                                    <div>{transferAccount[0].label}</div>
                                    <div style={{height : '20px'}}></div>
                                    <div><b>{transferAccount[1].label}</b></div>
                                </div>
                            </div>
                            <div style={{display : 'flex', alignItems : 'center', borderTop : '1.8px #000 solid'}}>
                                <div style={{flex : '1', paddingLeft : '10px'}}>
                                    <Input value={amount} onChange={val => {setAmount(val)}} placeholder="Transfer amount" type="number" style={{height : '38px'}}/>
                                </div>
                                <div onClick={()=>{setVisiblePopup(true)}} style={{
                                    padding : '0 12px',
                                    fontWeight : 'bold',  
                                    height:'38px', 
                                    borderLeft : '1.8px #000 solid',
                                    display : 'flex',
                                    alignItems : 'center',
                                    }}>{symbol} <DownFill fontSize={10} style={{ marginBottom : '2px', padding : '2px'}}/></div>
                            </div>
                        </div>
                    </List.Item>

                    <List.Item style={{fontSize : '14px', margin : '15px 0'}}>
                        Balance: {balance} {symbol} <b onClick={onClickAll}>Transfer All</b>
                    </List.Item>
                    <List.Item>
                        <ButtonView onClick={postTransfer}>Transfer</ButtonView>
                    </List.Item>
                    <CellHeaderView>Transfer history</CellHeaderView>
                    <CellRecordView left='Amount' center='Record' right='Time' color='#B0B0B0' style={{margin: '20px 0'}}/>
                    <CellStateView stateType={stateCode} onRefresh={()=>{requestData()}}/>
                    {
                        dataSource.map((item, index) => (
                            <CellRecordView 
                                key={index} 
                                border={true} 
                                left={item.amount || 0} 
                                center={`${AssetsGetName(item.from_type)} to ${AssetsGetName(item.to_type)} to ${item.symbol}`} 
                                right={<span style={{color : '#999'}}>{ToDate(item.creationDate)}</span>}/>
                        ))
                    }
                </ListView>
            </BodyView>
            <PopupSelectView visible={visiblePopup} close={()=>{setVisiblePopup(false)}}>
                {
                    (assetsData.current[formType] || []).map((item, index) => (
                        <CellAssetsView onClick={()=>{openAccount(item)}} key={index} item={item}/>
                    ))
                }
            </PopupSelectView>
        </>
    );
}
export default React.memo(AssetsTransferViewController)